module.exports = __webpack_public_path__ + "img/step_6.e4619c87.png";